module.exports = __webpack_public_path__ + "img/yqltdnbanners.892f15f3.png";